// removed by extract-text-webpack-plugin
module.exports = {"container":"container_2A6wN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/footer/style.css
 ** module id = 944
 ** module chunks = 0
 **/